import { useParams } from 'react-router-dom';
import GeneralAnalytics from './general_report';
import StaffReport from './staff_report';
import DriverReport from './driver_report';

export default function Analytics() {
  const { slug } = useParams();
  switch (slug) {
    case 'employees':
      return <StaffReport />;
    case 'drivers':
      return <DriverReport />;

    default:
      return <GeneralAnalytics />;
  }
}

